import { UserProfile, useUser } from '../lib/auth';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Home, BadgeCheck } from 'lucide-react';
import { api } from '@/lib/api';

export default function ProfilePage() {
  const { user } = useUser();
  const qc = useQueryClient();

  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me() });

  const becomeHost = useMutation({
    mutationFn: () => api.becomeHost(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['me'] }),
  });

  const isHost = me.data?.role === 'host' || me.data?.role === 'admin';

  return (
    <div className="yd-container space-y-6 py-8">
      <header>
        <h1 className="font-display text-2xl font-bold text-ink-900">Profil</h1>
        <p className="text-sm text-ink-500">Hesap bilgilerinizi ve ev sahipliği durumunuzu yönetin.</p>
      </header>

      {/* Host status card */}
      <section className="yd-card flex flex-wrap items-center justify-between gap-4 p-5" data-testid="host-status-card">
        <div className="flex items-center gap-3">
          <span className="grid h-11 w-11 place-items-center rounded-full bg-sand-100 text-sand-700">
            {isHost ? <BadgeCheck className="h-5 w-5" /> : <Home className="h-5 w-5" />}
          </span>
          <div>
            <p className="font-semibold text-ink-900">
              {isHost ? 'Ev Sahibi Hesabı Aktif' : 'Mülkünüzü Yalıda Davet’te Listeleyin'}
            </p>
            <p className="text-sm text-ink-500">
              {isHost
                ? 'İlanlarınızı “İlanlarım” sekmesinden yönetebilirsiniz.'
                : 'Ev sahibi olarak yalınızı özel organizasyonlar için kiraya verin.'}
            </p>
          </div>
        </div>

        {!isHost && (
          <button
            type="button"
            className="yd-btn-primary"
            onClick={() => becomeHost.mutate()}
            disabled={becomeHost.isPending}
            data-testid="become-host-btn"
          >
            {becomeHost.isPending ? 'İşleniyor...' : 'Ev Sahibi Ol'}
          </button>
        )}
      </section>

      {/* Clerk-managed account settings */}
      <section data-testid="clerk-user-profile">
        <UserProfile
          appearance={{ elements: { rootBox: 'w-full', cardBox: 'w-full shadow-none border border-ink-100' } }}
          routing="hash"
        />
      </section>

      {user && (
        <p className="text-center text-xs text-ink-400">
          Oturum: {user.primaryEmailAddress?.emailAddress}
        </p>
      )}
    </div>
  );
}
